import Vue from 'vue';
import Router from 'vue-router';
import Search from '@/components/Search';
import Fetch from '@/components/Fetch';
import Results from '@/components/Results';
import Cart from '@/components/Cart';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Search',
      component: Search,
    },
    {
      path: '/fetch/:fromLocality/:toLocality/:searchId',
      name: 'Fetch',
      component: Fetch,
      // https://medium.com/@BjornKrols/tutorial-dynamic-content-via-url-query-parameters-in-vue-js-d2df19b66633
      props: true,
      // use guard to prevent going back to the fetch page from the results page
      // https://router.vuejs.org/en/advanced/navigation-guards.html
      beforeEnter: (to, from, next) => {
        if (from.name === 'Results') next({name: 'Search'});
        else next();
      }
    },
    {
      path: '/results/:fromLocality/:toLocality/:searchId/:direction',
      name: 'Results',
      component: Results,
      props: true,
    },
    {
      path: '/cart/:fromLocality/:toLocality',
      name: 'Cart',
      component: Cart,
      props: true
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js